import { Device } from "@fairfleet/geotab";
import { GridColumnHeaders } from "@mui/x-data-grid-pro";
import { useEffect, useMemo } from "react";
import { useDeviceFirmwareData } from "../hooks/useDeviceFirmwareData";
import ColumnMenu from "@/components/columnMenu/ColumnMenu";
import { I18nGrid } from "@/components/data/I18nGrid";
import { useDataGridSettings } from "@/components/DataGridSettingsProvider";
import CustomToolbar from "@/components/grid/CustomToolbar";
import useFirmwareColumns from "@/hooks/columns/useFirmwareColumns";

interface Props {
  devices: Device[];
  loadingDevices: boolean;
}

export default function DeviceFirmwareGrid({ devices, loadingDevices }: Props) {
  const { apiRef, columns, loading, gridState } = useDataGridSettings();
  const { initialColumns } = useFirmwareColumns();

  const { data = [] } = useDeviceFirmwareData(devices);

  useEffect(() => {
    if (!loading && gridState) {
      apiRef.current.restoreState(gridState);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gridState, initialColumns, loading]);

  const cols = useMemo(() => [...initialColumns, ...columns], [columns, initialColumns]);

  return (
    <I18nGrid
      apiRef={apiRef}
      loading={loadingDevices}
      columns={cols}
      rows={data}
      getRowId={row => row?.device.id}
      slots={{
        columnHeaders: GridColumnHeaders,
        toolbar: CustomToolbar,
        columnMenu: ColumnMenu,
      }}
      slotProps={{
        loadingOverlay: {
          variant: "linear-progress",
          noRowsVariant: "skeleton",
        },
      }}
      disableRowSelectionOnClick
    />
  );
}
